import 'flag-icons/css/flag-icons.min.css';

interface FlagProps {
  country: string;
  className?: string;
  title?: string;
}

const EMOJI_TO_ISO: Record<string, string> = {
  '🇬🇧': 'gb', '🇺🇸': 'us', '🇨🇦': 'ca', '🇫🇷': 'fr', '🇩🇪': 'de',
  '🇯🇵': 'jp', '🇦🇺': 'au', '🇳🇱': 'nl', '🇨🇳': 'cn', '🇮🇳': 'in',
  '🇮🇹': 'it', '🇪🇸': 'es', '🇲🇽': 'mx', '🇧🇷': 'br', '🇰🇷': 'kr',
  '🇸🇪': 'se', '🇨🇭': 'ch', '🇧🇪': 'be', '🇦🇹': 'at', '🇩🇰': 'dk',
  '🇮🇪': 'ie', '🇫🇮': 'fi', '🇳🇴': 'no', '🇵🇹': 'pt', '🇵🇱': 'pl',
  '🇸🇬': 'sg', '🇿🇦': 'za', '🇮🇱': 'il', '🇦🇪': 'ae', '🇸🇦': 'sa',
  '🇹🇭': 'th', '🇹🇷': 'tr', '🇷🇺': 'ru', '🇦🇷': 'ar', '🇨🇱': 'cl',
  '🇨🇴': 'co', '🇵🇪': 'pe', '🇻🇪': 've', '🇳🇿': 'nz', '🇲🇾': 'my',
  '🇮🇩': 'id', '🇵🇭': 'ph', '🇻🇳': 'vn', '🇪🇬': 'eg', '🇳🇬': 'ng',
  '🇰🇪': 'ke',
};

export function emojiToIso(emoji: string | undefined | null): string | null {
  if (!emoji) return null;
  return EMOJI_TO_ISO[emoji] ?? null;
}

export function Flag({ country, className = '', title }: FlagProps) {
  const iso = country.length === 2 ? country.toLowerCase() : emojiToIso(country);
  if (!iso) {
    return (
      <span className={className} title={title} aria-label={country}>
        {country}
      </span>
    );
  }
  return (
    <span
      className={`fi fi-${iso} ${className}`}
      role="img"
      aria-label={title || iso.toUpperCase()}
      title={title}
      style={{ display: 'inline-block', width: '1.25em', height: '0.9375em', verticalAlign: 'middle' }}
    />
  );
}

export default Flag;
